import { z } from 'zod';
/**
 * Phase 4.75d — driver location ingest + reads.
 */
export const DRIVER_LOCATION_MAX_BATCH = 200;
const latSchema = z.number().min(-90).max(90);
const lngSchema = z.number().min(-180).max(180);
const accuracySchema = z.number().nonnegative().max(100_000); // 100km accuracy upper bound is silly-loose
const speedSchema = z.number().nonnegative().max(150); // 150 m/s = 540 km/h, plenty
const headingSchema = z.number().min(0).lt(360);
const batterySchema = z.number().int().min(0).max(100);
export const driverLocationIngestPointSchema = z.object({
    recordedAt: z.string().datetime({ offset: true }),
    lat: latSchema,
    lng: lngSchema,
    accuracyM: accuracySchema.nullish(),
    speedMps: speedSchema.nullish(),
    headingDeg: headingSchema.nullish(),
    batteryPct: batterySchema.nullish(),
    loadId: z.string().length(26).nullish(),
    /**
     * Duty-scoped sharing (ruling 2026-08-07): an on-duty point between
     * jobs names its fleet directly — the server verifies active
     * membership and stamps fleet_id so the live map can see it. Ignored
     * when loadId is present (the load's fleet wins).
     */
    fleetId: z.string().length(26).nullish(),
});
export const driverLocationIngestSchema = z.object({
    points: z
        .array(driverLocationIngestPointSchema)
        .min(1)
        .max(DRIVER_LOCATION_MAX_BATCH),
});
/** Path param for the dispatcher's per-driver locations endpoint. */
export const driverIdParamSchema = z.object({
    userId: z.string().length(26),
});
/** Query string for load-locations read. */
export const loadLocationsQuerySchema = z.object({
    /** Limit number of points returned. Defaults to 500. */
    limit: z.coerce.number().int().min(1).max(5000).default(500),
});
//# sourceMappingURL=driver-location.js.map